var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDispatcherDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 7,
    r: 6,
    stroke: "#9F9A9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49978 8.09755C6.41742 8.09769 6.33585 8.08156 6.25975 8.05007C6.18366 8.01859 6.11453 7.97238 6.05635 7.91409L4.39648 6.25391L4.83991 5.81049L6.49978 7.47035L8.15964 5.81049L8.60307 6.25391L6.9432 7.91378C6.88505 7.97212 6.81593 8.01839 6.73983 8.04993C6.66373 8.08146 6.58215 8.09765 6.49978 8.09755Z",
    fill: "#8E9397"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatcherDropdown);
export default __webpack_public_path__ + "static/media/dispatcher-dropdown.dccc1575a8bf54b7f4d4a7330bb39bd8.svg";
export { ForwardRef as ReactComponent };